import { render, staticRenderFns } from "./DescuentoTooltip.vue?vue&type=template&id=4e8dd87e&"
import script from "./DescuentoTooltip.vue?vue&type=script&lang=js&"
export * from "./DescuentoTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports